import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyCallButton from "@/components/StickyCallButton";
import Home from "@/pages/Home";
import Barbers from "@/pages/Barbers";
import Shop from "@/pages/Shop";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Booking from "@/pages/Booking";
import Contact from "@/pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App grain min-h-screen text-monarch-cream">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="relative z-[2]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/barbers" element={<Barbers />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:id" element={<JournalPost />} />
            <Route path="/book" element={<Booking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <StickyCallButton />
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid rgba(212, 175, 55, 0.4)",
              color: "#FAFAFA",
              borderRadius: "0",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
